import React, { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import jsPDF from "jspdf";
import "jspdf-autotable";
import logo from "./../../assest/logo-my-color-event.png";
import noImage from "./../../assest/icon/no-image.png";
import deliveryTruck from "./../../assest/icon/delivery-truck1.png";
import PoppinsRegular from "./../../assest/font/Poppins-Regular.ttf"; // Path to your font file
import PoppinsBold from "./../../assest/font/Poppins-Bold.ttf"; // Path to your font file
import LoaderSpinner from "../../Components/pageLoader/LoaderSpinner";
import { useRef } from "react";
import { useReactToPrint } from "react-to-print";

const OrderDetailsPage = () => {
  const { id } = useParams();
  const [products, setProducts] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [paymentData, setPaymentData] = useState([]);
  const [totalPayAmount, setTotalPayAmount] = useState(0);

  const componentRef = useRef();

  const allSet = products?.set || [];
  const personEmail = products?.email;

  const invoicePaymentId = products?.paymentId;

  console.log(paymentData);

  useEffect(() => {
    if (personEmail && invoicePaymentId) {
      const fetchPaymentData = async () => {
        try {
          const response = await axios.get(
            `https://server-gs.vercel.app/paid/stripe/${personEmail}/${invoicePaymentId}`
          );

          // Check if response.data is not empty
          if (response.data && response.data.length > 0) {
            setPaymentData(response.data);

            // Calculate the total payAmount if available
            const total = response.data.reduce(
              (acc, payment) => acc + (parseFloat(payment?.payAmount) || 0),
              0
            );
            setTotalPayAmount(total?.toFixed(2)); // Ensure two decimal places
          } else {
            // If there's no data, set paymentData to an empty array and totalPayAmount to 0.00
            setPaymentData([]);
            setTotalPayAmount(0);
          }
        } catch (err) {
          if (err.response && err.response.status === 404) {
            // Handle 404 error specifically
            console.log("No records found for this email and invoicePaymentId");
            setPaymentData([]); // Clear payment data
            setTotalPayAmount(0); // Reset total pay amount
            setError("No payment records found."); // Set a user-friendly error message
          } else {
            // Handle other errors
            console.error("Error fetching payment data:", err);
            setError("Failed to fetch payment data. Please try again later.");
          }
        }
      };

      fetchPaymentData();
    }
  }, [personEmail, invoicePaymentId]);

  const fetchProductDetails = async () => {
    try {
      const response = await fetch(
        `https://server-gs.vercel.app/admin/orders/${id}`
      );
      const data = await response.json();
      setProducts(data);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching product details:", error);
    }
  };

  useEffect(() => {
    fetchProductDetails();
    const interval = setInterval(() => {
      fetchProductDetails();
    }, 1000);
    return () => clearInterval(interval);
  }, [id]);

  const calculateTotalPrice = (pro) => {
    let priceAfterDiscount = pro?.selectedPricingValue;

    // Apply discount to the selectedPricingValue first
    if (pro?.discount) {
      const discountValue =
        pro.discountType === "%"
          ? (parseFloat(pro.discount) / 100) * priceAfterDiscount
          : parseFloat(pro.discount);

      priceAfterDiscount -= discountValue;
    }

    // Multiply the discounted price by the quantity
    let total = pro.quantity * priceAfterDiscount;

    // Add tax after applying discount and calculating the total
    if (pro?.tax) {
      const taxValue = (parseFloat(pro.tax) / 100) * total;
      total += taxValue;
    }

    // Ensure total is not negative
    return Math.max(0, total).toFixed(2);
  };

  const calculateTotalTaxAmount = (pro) => {
    // Convert all numerical values to numbers
    const price = parseFloat(pro.selectedPricingValue) || 0;
    const quantity = parseInt(pro.quantity) || 1;

    let priceAfterDiscount = price;

    // Apply discount if exists
    if (pro?.discount) {
      const discountAmount = parseFloat(pro.discount) || 0;
      const discountValue =
        pro.discountType === "%"
          ? (discountAmount / 100) * priceAfterDiscount
          : discountAmount;

      priceAfterDiscount = Math.max(0, priceAfterDiscount - discountValue);
    }

    // Calculate subtotal (after discount)
    const subtotal = quantity * priceAfterDiscount;

    // Calculate tax amount if tax exists
    if (pro?.tax) {
      const taxRate = parseFloat(pro.tax) || 0;
      return ((taxRate / 100) * subtotal).toFixed(2);
    }

    return "0.00"; // Return 0 if no tax
  };

  const calculateSubTotalPrice = (pro) => {
    return pro?.quantity * pro?.selectedPricingValue;
  };

  const calculateWithDiscountPrice = (pro) => {
    let priceAfterDiscount = pro?.selectedPricingValue;

    // Apply discount to the selectedPricingValue first
    if (pro?.discount) {
      const discountValue =
        pro.discountType === "%"
          ? (parseFloat(pro.discount) / 100) * priceAfterDiscount
          : parseFloat(pro.discount);

      priceAfterDiscount -= discountValue;
    }

    // Multiply the discounted price by the quantity
    let total = pro?.quantity * priceAfterDiscount;

    // Ensure total is not negative
    return Math.max(0, total).toFixed(2);
  };

  const calculateProductDiscountPrice = (pro) => {
    const totalWithoutDiscount = parseFloat(calculateSingleTotalPrice(pro));
    const totalWithDiscount = parseFloat(calculateWithDiscountPrice(pro));

    // Calculate the difference
    const discountAmount = totalWithoutDiscount - totalWithDiscount;

    // Ensure the discount amount is not negative
    return Math.max(0, discountAmount).toFixed(2);
  };

  const calculateSingleTotalPrice = (pro) => {
    if (!pro || typeof pro !== "object") return "0.00";

    const quantity = Number(pro?.quantity) || 0;
    const price = Number(pro?.selectedPricingValue) || 0;

    const total = quantity * price;

    return total > 0 ? total.toFixed(2) : "0.00";
  };

  const calculateSetSubTotal = (products) => {
    return products
      .reduce((acc, pro) => acc + calculateSubTotalPrice(pro), 0)
      .toFixed(2);
  };

  const calculateSetTotal = (products) => {
    // Ensure products is always an array
    const productList = Array.isArray(products) ? products : [];

    // Calculate the total by summing up discounted price and tax for each product
    const total = productList.reduce((acc, pro) => {
      const discountedPrice = parseFloat(calculateWithDiscountPrice(pro)) || 0;
      const taxTotal = parseFloat(calculateTaxTotal([pro])) || 0; // Pass as array to avoid errors
      return acc + discountedPrice + taxTotal;
    }, 0);

    // Format the total to 2 decimal places
    return total.toFixed(2);
  };

  const calculateDiscountTotal = (products) => {
    return products
      .reduce((acc, pro) => {
        if (pro?.discount) {
          let discountValue = 0;

          if (pro?.discountType === "%") {
            // For percentage discount, calculate based on the subtotal
            const subtotal = pro?.quantity * pro?.selectedPricingValue;
            discountValue = (parseFloat(pro?.discount) / 100) * subtotal;
          } else if (pro?.discountType === "$") {
            // For fixed amount discount, apply the discount directly (do not multiply by quantity)
            discountValue = parseFloat(pro?.discount);
          }

          acc += discountValue; // Accumulate the discount value
        }
        return acc;
      }, 0)
      .toFixed(2); // Return the total discount rounded to 2 decimal places
  };

  const calculateAllDiscountTotal = (products) => {
    return products
      .reduce((acc, pro) => {
        // Calculate the total price without discount
        const totalWithoutDiscount = parseFloat(calculateSingleTotalPrice(pro));

        // Calculate the total price with discount
        const totalWithDiscount = parseFloat(calculateWithDiscountPrice(pro));

        // Calculate the discount for this product
        const discount = totalWithoutDiscount - totalWithDiscount;

        // Add the discount to the accumulator
        return acc + discount;
      }, 0)
      .toFixed(2); // Return the total discount rounded to 2 decimal places
  };

  const calculateTaxTotal = (products) => {
    return products
      .reduce((totalTax, product) => {
        // Get base price or default to 0
        const price = parseFloat(product.selectedPricingValue) || 0;
        const quantity = parseInt(product.quantity) || 1;

        // Apply discount if exists
        let priceAfterDiscount = price;
        if (product?.discount) {
          const discountAmount = parseFloat(product.discount) || 0;
          const discountValue =
            product.discountType === "%"
              ? (discountAmount / 100) * priceAfterDiscount
              : discountAmount;
          priceAfterDiscount = Math.max(0, priceAfterDiscount - discountValue);
        }

        // Calculate subtotal after discount
        const subtotal = quantity * priceAfterDiscount;

        // Calculate tax for this product if tax exists
        const productTax = product?.tax
          ? (parseFloat(product.tax) / 100) * subtotal
          : 0;

        return totalTax + productTax;
      }, 0)
      .toFixed(2);
  };

  const calculateAllSetSubTotal = (allSet) => {
    return allSet
      .reduce((total, perSet) => {
        // Calculate the subtotal for each set, using the correct array of products
        const setTotal = parseFloat(calculateSetSubTotal(perSet.products)); // Fix here
        return total + setTotal;
      }, 0)
      .toFixed(2);
  };

  const calculateAllSetTotal = (allSet) => {
    return allSet
      .reduce((total, perSet) => {
        const setTotal = perSet.products.reduce(
          (acc, pro) => acc + parseFloat(calculateTotalPrice(pro)),
          0
        );
        return total + setTotal;
      }, 0)
      .toFixed(2);
  };

  const calculateAllSetDiscount = (allSet) => {
    return allSet
      .reduce((total, perSet) => {
        const setDiscount = perSet.products.reduce((acc, pro) => {
          return acc + parseFloat(calculateProductDiscountPrice(pro));
        }, 0);

        return total + setDiscount;
      }, 0)
      .toFixed(2); // Round to 2 decimal places
  };

  // Function to calculate All Set Tax
  const calculateAllSetTax = (allSet) => {
    return allSet
      .reduce((totalSetsTax, perSet) => {
        // Calculate tax for all products in this set
        const setTax = perSet.products.reduce(
          (productTaxAccumulator, product) => {
            // Get base price or default to 0
            const price = parseFloat(product.selectedPricingValue) || 0;
            const quantity = parseInt(product.quantity) || 1;

            // Apply discount if exists
            let priceAfterDiscount = price;
            if (product?.discount) {
              const discountAmount = parseFloat(product.discount) || 0;
              const discountValue =
                product.discountType === "%"
                  ? (discountAmount / 100) * priceAfterDiscount
                  : discountAmount;
              priceAfterDiscount = Math.max(
                0,
                priceAfterDiscount - discountValue
              );
            }

            // Calculate subtotal after discount
            const subtotal = quantity * priceAfterDiscount;

            // Calculate tax for this product if tax exists
            return (
              productTaxAccumulator +
              (product?.tax ? (parseFloat(product.tax) / 100) * subtotal : 0)
            );
          },
          0
        );

        return totalSetsTax + setTax;
      }, 0)
      .toFixed(2); // Total tax for all sets
  };

  const calculateFinalTotal = (allSet, products) => {
    // Calculate the total for all sets
    const total = calculateAllSetTotal(allSet);

    // Get the discount value and type
    const discount = parseFloat(products?.AllProductDiscount) || 0;
    const discountType = products?.AllProductDiscountType;

    let finalTotal = parseFloat(total);

    // Apply discount based on the discount type
    if (discountType === "$") {
      // Subtract fixed amount discount
      finalTotal -= discount;
    } else if (discountType === "%") {
      // Subtract percentage discount
      finalTotal -= (discount / 100) * finalTotal;
    }

    // Ensure the final total is not negative
    return Math.max(0, finalTotal).toFixed(2);
  };

  const calculateDeposit = (
    finalTotal,
    advanceDepositValue,
    advanceDepositType
  ) => {
    if (!advanceDepositValue || !advanceDepositType || isNaN(finalTotal)) {
      return "0.00"; // Default to 0 if inputs are invalid
    }

    let depositAmount = 0;

    if (advanceDepositType === "%") {
      // If the deposit type is percentage, calculate based on finalTotal
      depositAmount =
        (parseFloat(advanceDepositValue) / 100) * parseFloat(finalTotal);
    } else if (advanceDepositType === "$") {
      // If the deposit type is fixed dollar amount, use the given value
      depositAmount = parseFloat(advanceDepositValue);
    }

    // Ensure depositAmount is not negative and format it to 2 decimal places
    return Math.max(0, depositAmount).toFixed(2);
  };

  const calculateAmountDue = (allSet, products, totalPayAmount) => {
    const finalTotal = parseFloat(calculateFinalTotal(allSet, products)); // Call the function
    return (finalTotal - totalPayAmount).toFixed(2); // Subtract totalPayAmount
  };

  const calculateDiscountSelectedPrice = (pro) => {
    let price = pro?.selectedPricingValue;

    // Apply discount first
    if (pro?.discount) {
      const discountValue =
        pro?.discountType === "%"
          ? (parseFloat(pro?.discount) / 100) * price
          : parseFloat(pro?.discount);

      price -= discountValue;
    }

    // Ensure total is not negative
    return Math.max(0, price).toFixed(2);
  };

  const amountDue = calculateAmountDue(allSet, products, totalPayAmount);

  const [data, setData] = useState(null);
  const [selectedOption, setSelectedOption] = useState("");

  const dataTermsConditions = products?.termsConditions;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          "https://server-gs.vercel.app/event-company-profile"
        );
        setData(response.data);
        setError(null); // Clear any previous errors

        // Only set the default option if the user hasn't manually selected an option
        if (response.data) {
          const matchedField = Object.keys(response.data).find(
            (key) => key === dataTermsConditions
          );

          // If a match is found, set the matched field as the default
          if (matchedField) {
            setSelectedOption(matchedField);
          }
        }
      } catch (err) {
        setError(err.message || "Something went wrong");
      } finally {
        setLoading(false);
      }
    };

    // Fetch data every second
    const intervalId = setInterval(fetchData, 1000);

    // Cleanup the interval on component unmount
    return () => clearInterval(intervalId);
  }, [dataTermsConditions]); // Add isUserSelected as a dependency

  const renderSelectedContent = () => {
    if (!data) return null;

    // If selectedOption matches a field in data, return its value
    if (selectedOption && data[selectedOption]) {
      return data[selectedOption];
    }

    // If dataTermsConditions matches a field in data, return its value as default
    if (dataTermsConditions && data[dataTermsConditions]) {
      return data[dataTermsConditions];
    }

    // Fallback if no match is found
    return "Please select an option.";
  };

  const addTermsAndConditions = (doc, data) => {
    if (data?._id) {
      // Ultra-compact settings
      const fontSize = 10;
      const lineHeight = fontSize * 0.85; // Very tight line spacing
      const fontFamily = "helvetica";
      const pageWidth = 180;
      const leftMargin = 15;

      // Process content with special pattern preservation
      const contentDiv = document.createElement("div");
      contentDiv.innerHTML = renderSelectedContent()
        .replace(/&nbsp;/g, " ")
        .replace(/&amp;/g, "&")
        .replace(/<p>/g, "<div>")
        .replace(/<\/p>/g, "</div>")
        // Protect colon patterns from breaking
        .replace(/(\w+:\s*\d+)/g, '<span class="nobreak">$1</span>');

      // PDF Generation
      doc.addPage();
      let y = 20;

      // Title
      doc.setFont(fontFamily, "bold");
      doc.setFontSize(10);
      doc.text("TERMS AND CONDITIONS", 105, y, { align: "center" });
      y += 8; // Tight title spacing

      // Main content
      doc.setFont(fontFamily, "normal");
      doc.setFontSize(fontSize);

      const processNode = (
        node,
        indent = 0,
        isListItem = false,
        listNumber = 0
      ) => {
        const currentMargin = leftMargin + indent * 5;
        const textWidth = pageWidth - indent * 5;

        if (node.nodeType === Node.TEXT_NODE) {
          const text = node.textContent.replace(/\s+/g, " ").trim();
          if (text) {
            // Special handling for non-breaking patterns
            if (node.parentNode.classList?.contains("nobreak")) {
              if (y > 280) {
                doc.addPage();
                y = 20;
              }
              doc.text(text, currentMargin, y);
              y += lineHeight;
            } else {
              const lines = doc.splitTextToSize(text, textWidth);
              for (const line of lines) {
                if (y > 280) {
                  doc.addPage();
                  y = 20;
                }
                doc.text(line, currentMargin, y);
                y += lineHeight;
              }
            }
          }
        } else if (node.nodeType === Node.ELEMENT_NODE) {
          const tag = node.tagName.toLowerCase();

          switch (true) {
            case tag === "div": // Paragraphs
              if (y > 20) y += 1; // Minimal 2pt spacing
              Array.from(node.childNodes).forEach((c) =>
                processNode(c, indent)
              );
              break;

            case tag === "br":
              y += lineHeight;
              break;

            case tag === "strong" || tag === "b":
              doc.setFont(undefined, "bold");
              Array.from(node.childNodes).forEach((c) =>
                processNode(c, indent, isListItem, listNumber)
              );
              doc.setFont(undefined, "normal");
              break;

            case tag === "ol":
              Array.from(node.children).forEach((li, i) => {
                const bullet = `${i + 1}.`;
                doc.text(bullet, currentMargin - 4, y + 1);
                processNode(li.firstChild, indent + 1, true, i + 1);
              });
              break;

            case tag === "ul":
              Array.from(node.children).forEach((li) => {
                doc.text("•", currentMargin - 4, y + 1);
                processNode(li.firstChild, indent + 1, true);
              });
              break;

            case tag === "span" && node.classList.contains("nobreak"):
              if (y > 280) {
                doc.addPage();
                y = 20;
              }
              doc.text(node.textContent, currentMargin, y);
              y += lineHeight;
              break;

            default:
              Array.from(node.childNodes).forEach((c) =>
                processNode(c, indent)
              );
          }
        }
      };

      // Process content
      Array.from(contentDiv.childNodes).forEach((node) => processNode(node));
      addFooter(doc);
    }
  };

  const addPaymentDetails = (
    doc,
    paymentData,
    startY,
    tableWidth,
    leftMargin
  ) => {
    let finalY = startY;

    // Add the "Payment received" title
    doc.setFont("Poppins", "bold");
    doc.setFontSize(14);
    doc.setTextColor(100, 100, 100); // Gray text color
    doc.text("Payment Received", leftMargin, finalY); // Right-aligned title
    finalY += 5;

    // Add each payment detail in a card-like format
    if (paymentData?.length > 0) {
      paymentData?.forEach((payment, index) => {
        // Check if there's enough space for the next payment card
        const cardHeight = 30; // Approximate height of each payment card
        if (finalY + cardHeight > doc.internal.pageSize.height - 20) {
          doc.addPage();
          finalY = 10; // Reset Y position for the new page
        }

        // Draw a rounded rectangle for the card
        doc.setDrawColor(200, 200, 200); // Light gray border
        doc.setFillColor(240, 240, 240); // Light gray background
        doc.roundedRect(
          leftMargin, // X position (right-aligned)
          finalY, // Y position
          tableWidth, // Width (60% of page width)
          cardHeight, // Height
          1, // Border radius
          1, // Border radius
          "FD" // Fill and draw
        );

        // Add payment details inside the card
        doc.setFont("Poppins", "normal");
        doc.setFontSize(12);
        doc.setTextColor(0, 0, 0); // Black text color

        // Amount
        doc.text(`Amount: $${payment?.payAmount}`, leftMargin + 5, finalY + 10);

        // Payment Method
        if (payment?.paymentMethod) {
          doc.text(
            `Payment Method: ${payment?.paymentMethod}`,
            leftMargin + 5,
            finalY + 15
          );
        } else {
          doc.text("Payment Method: Stripe", leftMargin + 5, finalY + 20);
          doc.text(
            `Stripe ID: ${payment?.stripePaymentId}`,
            leftMargin + 5,
            finalY + 20
          );
        }

        // Payment Date
        const paymentDate = payment?.PaymentDate
          ? payment.PaymentDate
          : payment?.createdAt;

        doc.text(
          `Payment Date: ${new Date(paymentDate).toLocaleString("en-US", {
            month: "short",
            day: "numeric",
            year: "numeric",
            hour: "numeric",
            minute: "2-digit",
            hour12: true,
          })}`,
          leftMargin + 5,
          finalY + 20
        );

        // Update finalY for the next card
        finalY += cardHeight + 10; // Add spacing between cards
      });
    } else {
      // If no payment data, add a message
      doc.setFont("Poppins", "normal");
      doc.setFontSize(12);
      doc.text("No payments received.", leftMargin, finalY);
      finalY += 10;
    }

    return finalY; // Return the final Y position after adding payment details
  };

  const addFooter = (doc) => {
    try {
      const pageCount = doc.internal.getNumberOfPages();
      for (let i = 1; i <= pageCount; i++) {
        doc.setPage(i);
        doc.setFont("Poppins", "normal");
        doc.setFontSize(10);
        doc.text(
          `My Color Events and Design LLC | Page ${i} of ${pageCount}`,
          10,
          doc.internal.pageSize.height - 10
        );
      }
    } catch (error) {
      console.error("Error in addFooter:", error);
    }
  };

  /**
   * Converts HTML to clean plain text with proper spacing for PDF
   * @param {string} html - The HTML content to convert
   * @returns {string} Clean plain text with proper line breaks
   */
  const htmlToCleanPdfText = (html) => {
    if (!html) return "N/A";

    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;

    const processNode = (node) => {
      let result = "";

      if (node.nodeType === Node.TEXT_NODE) {
        return node.textContent.replace(/\s+/g, " ");
      }

      if (
        ["script", "style", "head", "title", "meta", "link"].includes(
          node.tagName?.toLowerCase()
        )
      ) {
        return "";
      }

      const tagName = node.tagName?.toLowerCase() || "";
      const children = Array.from(node.childNodes);

      // Handle spacing and line breaks
      switch (tagName) {
        case "div":
        case "p":
        case "section":
        case "article":
        case "header":
        case "footer":
          result += "\n\n";
          break;
        case "h1":
        case "h2":
        case "h3":
        case "h4":
        case "h5":
        case "h6":
          result += "\n\n";
          break;
        case "ul":
        case "ol":
          result += "\n";
          break;
        case "li":
          result += "\n • ";
          break;
        case "br":
          result += "\n";
          break;
        case "hr":
          result += "\n---\n";
          break;
      }

      // Process children
      children.forEach((child) => {
        result += processNode(child);
      });

      return result;
    };

    let text = "";
    Array.from(tempDiv.childNodes).forEach((node) => {
      text += processNode(node);
    });

    return cleanFinalText(text) || "N/A";
  };

  /**
   * Final text cleaning for PDF
   */
  const cleanFinalText = (text) => {
    return text
      .replace(/\r\n/g, "\n") // Standardize line breaks
      .replace(/\n{3,}/g, "\n\n") // Max 2 consecutive line breaks
      .replace(/[ \t]{2,}/g, " ") // Remove excessive spaces/tabs
      .replace(/(\n) /g, "$1") // Remove space after newline
      .replace(/ \n/g, "\n") // Remove space before newline
      .trim();
  };

  // Usage for PDF generation
  const renderDescriptionForPDF = (description) => {
    return htmlToCleanPdfText(description);
  };

  const generatePDFTwo = () => {
    const doc = new jsPDF();

    // Add Poppins fonts
    doc.addFont(PoppinsRegular, "Poppins", "normal");
    doc.addFont(PoppinsBold, "Poppins", "bold");

    // Set default font to Poppins
    doc.setFont("Poppins", "normal");
    doc.setTextColor(0, 0, 0); // Set text color to black

    let finalY = 10;

    // Add company logo
    const logoWidth = 36;
    const logoHeight = 36;
    doc.addImage(logo, "PNG", 10, finalY, logoWidth, logoHeight);

    // Add company details (aligned to the right of the logo)
    doc.setFont("Poppins", "bold");
    doc.setFontSize(14);
    doc.text("My Color Events and Design LLC", 55, finalY + 10);

    doc.setFont("Poppins", "normal");
    doc.setFontSize(10);
    doc.text("1565 Monroe Turnpike Monroe, ", 55, finalY + 17);
    doc.text("Connecticut 06468 United States", 55, finalY + 22);
    doc.text("info@mycolorevents.com", 55, finalY + 27);
    doc.text("Phone: +1203-548-7769", 55, finalY + 32);

    // Add quote and issue date (aligned to the right)
    doc.setFont("Poppins", "bold");
    doc.setFontSize(14);

    const paymentId = products.paymentId || "N/A";
    doc.text(`Quote: ${paymentId}`, 140, finalY + 10);

    doc.setFont("Poppins", "normal");
    doc.setFontSize(10);

    const issueDate = products.createdAt
      ? new Date(products.createdAt).toLocaleString("en-US", {
          month: "short",
          day: "numeric",
          year: "numeric",
          hour: "numeric",
          minute: "2-digit",
          hour12: true,
        })
      : "N/A";
    doc.text(`Issue Date: ${issueDate}`, 140, finalY + 17);

    // Add a horizontal line
    finalY += 40;
    doc.setDrawColor(0, 0, 0);
    doc.setLineWidth(0.5);
    doc.line(10, finalY, 200, finalY);
    finalY += 10;

    // Add contact and venue section
    doc.setFont("Poppins", "bold");
    doc.setFontSize(12);
    doc.text("Contact", 10, finalY);
    doc.text("Venue / Address", 100, finalY);
    finalY += 7;

    // Contact details
    doc.setFont("Poppins", "normal");
    doc.setFontSize(10);

    const fullName =
      `${products.firstName || ""} ${products.lastName || ""}`.trim() || "N/A";
    doc.text(`Name: ${fullName}`, 10, finalY);

    const phoneNumber = products.phoneNumber || "N/A";
    doc.text(`Phone: ${phoneNumber}`, 10, finalY + 5);

    const email = products.email || "N/A";
    doc.text(`Email: ${email}`, 10, finalY + 10);

    // Venue details
    const Address = products.address || "N/A";
    const splitAddress = doc.splitTextToSize(`Address: ${Address}`, 90); // Wrap text to fit within 90mm width
    doc.text(splitAddress, 100, finalY);

    const City = products.city || "N/A";
    doc.text(`City: ${City}`, 100, finalY + 5 + (splitAddress.length - 1) * 5);

    const State = products.state || "N/A";
    doc.text(
      `State: ${State}`,
      100,
      finalY + 10 + (splitAddress.length - 1) * 5
    );

    const postCode = products.postCode || "N/A";
    doc.text(
      `Post Code: ${postCode}`,
      100,
      finalY + 15 + (splitAddress.length - 1) * 5
    );

    // Add a horizontal line
    finalY += 20 + (splitAddress.length - 1) * 5;
    doc.line(10, finalY, 200, finalY);
    finalY += 5;

    // Function to check if there's enough space for a set
    const checkPageBreak = (requiredHeight) => {
      const pageHeight = doc.internal.pageSize.height;
      if (finalY + requiredHeight > pageHeight - 20) {
        doc.addPage();
        finalY = 5;
      }
    };

    // Add footer to every page
    const addFooter = () => {
      const pageCount = doc.internal.getNumberOfPages();
      for (let i = 0; i <= pageCount; i++) {
        doc.setPage(i);
        doc.setFont("Poppins", "normal");
        doc.setFontSize(10);
        doc.text(
          `My Color Events and Design LLC | Page ${i} of ${pageCount}`,
          10,
          doc.internal.pageSize.height - 10
        );
      }
    };

    allSet.forEach((perSet, index) => {
      if (perSet.products && perSet.products.length > 0) {
        const productsHeight = perSet.products.length * 10;
        const summaryHeight = 30;
        const totalSetHeight = productsHeight + summaryHeight + 30;

        checkPageBreak(totalSetHeight);

        // Add set title and date range
        doc.setFontSize(12);
        doc.setFillColor(59, 89, 152); // Set the background color for the header
        doc.rect(10, finalY, 190, 20, "F"); // Draw a filled rectangle for the header area

        doc.setTextColor(255, 255, 255); // White text for the header

        // Title on the left (top)
        const title = perSet.setTitle || "N/A";
        doc.text(`${title}`, 12, finalY + 8); // Position title at the top left

        // Date on the left, below the title
        const startDate = perSet.startDate
          ? new Date(perSet.startDate).toLocaleString("en-US", {
              month: "short",
              day: "numeric",
              year: "numeric",
              hour: "numeric",
              minute: "2-digit",
              hour12: true,
            })
          : "N/A";

        const endDate = perSet.endDate
          ? new Date(perSet.endDate).toLocaleString("en-US", {
              month: "short",
              day: "numeric",
              year: "numeric",
              hour: "numeric",
              minute: "2-digit",
              hour12: true,
            })
          : "N/A";

        // Position the date below the title
        const dateText = `${startDate} - ${endDate}`;
        doc.setFontSize(10);
        doc.text(`${dateText}`, 12, finalY + 14); // Position date below title

        // Increase finalY to move down for the next section
        finalY += 18; // Increase finalY to prevent overlap with the next section

        const tableData = perSet.products.map((pro) => {
          let descriptionContent = "";

          if (pro?.title) {
            descriptionContent += `${pro.title}\n`;
          }

          if (pro?.deliveryType === "tear") {
            // Do nothing or handle the "tear" case if needed
          } else if (pro?.deliveryType === "delivery" && pro?.startDate) {
            descriptionContent += `Start Date: ${new Date(
              pro.startDate
            ).toLocaleString("en-US", {
              month: "short",
              day: "numeric",
              year: "numeric",
              hour: "numeric",
              minute: "2-digit",
              hour12: true,
            })}\n`;
          } else if (pro?.productCode) {
            descriptionContent += `Product Code: ${pro.productCode}\n`;
          }

          // descriptionContent += `Des: ${pro?.description || "N/A"}\n`;

          descriptionContent += `Description: ${renderDescriptionForPDF(
            pro?.description
          )}\n`;

          let attributes = [];
          if (pro?.color && pro.color.trim() !== "" && /\d/.test(pro.color)) {
            attributes.push(`Color: ${pro.color}`);
          }
          if (
            pro?.height &&
            pro.height.trim() !== "" &&
            /\d/.test(pro.height)
          ) {
            attributes.push(`Height: ${pro.height}`);
          }
          if (
            pro?.length &&
            pro.length.trim() !== "" &&
            /\d/.test(pro.length)
          ) {
            attributes.push(`Length: ${pro.length}`);
          }
          if (pro?.width && pro.width.trim() !== "" && /\d/.test(pro.width)) {
            attributes.push(`Width: ${pro.width}`);
          }
          if (pro?.shape && pro.shape.trim() !== "" && /\d/.test(pro.shape)) {
            attributes.push(`Shape: ${pro.shape}`);
          }

          if (attributes.length > 0) {
            descriptionContent += attributes.join(", ") + "\n";
          }

          if (pro?.internalNotes) {
            descriptionContent += `Notes: ${pro.internalNotes}`;
          }

          return [
            "", // Product Image
            descriptionContent, // Updated detailed description
            pro?.quantity || "N/A", // Quantity
            "", // Price
            "", // Total
          ];
        });

        checkPageBreak(20 + tableData.length * 10);

        doc.autoTable({
          head: [["", "Description", "Quantity", "Price", "Total"]],
          body: tableData,
          startY: finalY,
          margin: { left: 10, right: 10 },
          tableWidth: 190,
          styles: {
            fontSize: 10,
            cellPadding: 3,
            textColor: [0, 0, 0],
            fontStyle: "normal",
            valign: "middle",
          },
          columnStyles: {
            0: { cellWidth: 40 },
            1: { cellWidth: 70, halign: "left", valign: "top" },
            2: { cellWidth: 20, halign: "center", valign: "middle" },
            3: { cellWidth: 30, halign: "left", valign: "middle" },
            4: { cellWidth: 30, halign: "left", valign: "middle" },
          },
          bodyStyles: { fillColor: [255, 255, 255] },
          headStyles: {
            fillColor: [250, 250, 250],
            textColor: [0, 0, 0],
            fontSize: 10,
            cellPadding: 3,
          },
          didParseCell: (data) => {
            if (data.row.section === "head") {
              data.cell.styles.minCellHeight = 10;
            } else if (data.row.section === "body") {
              data.cell.styles.minCellHeight = 30;
              if (data.column.index === 0 || data.column.index === 1) {
                data.cell.styles.fillColor = [255, 255, 255];
              } else if (data.column.index === 2) {
                data.cell.styles.fillColor = [250, 250, 250];
              } else if (data.column.index === 3) {
                data.cell.styles.fillColor = [245, 245, 245];
              } else if (data.column.index === 4) {
                data.cell.styles.fillColor = [229, 229, 229];
              }
            }
          },
          didDrawCell: (data) => {
            if (data.column.index === 0 && data.row.section === "body") {
              const product = perSet.products[data.row.index];

              let imageUrl = product?.singleImage;
              let imgWidth = 25;
              let imgHeight = 25;

              // If it's a delivery product, show the truck icon with a different size
              if (product?.deliveryType === "delivery") {
                imageUrl = deliveryTruck;
                imgWidth = 25;
                imgHeight = 20;
              }

              if (imageUrl) {
                const img = new Image();
                img.src = imageUrl;

                const x = data.cell.x + (data.cell.width - imgWidth) / 2;
                const y = data.cell.y + (data.cell.height - imgHeight) / 2;

                doc.addImage(img, "PNG", x, y, imgWidth, imgHeight);
              }
            }

            if (data.column.index === 3 && data.row.section === "body") {
              const product = perSet.products[data.row.index];
              const discountedPrice = calculateDiscountSelectedPrice(product);
              const originalPrice = product?.selectedPricingValue || "0.00";

              const discountText = `$${discountedPrice}`;
              const originalText = `$${originalPrice}`;

              const textX = data.cell.x + data.cell.width / 2;
              const cellCenterY = data.cell.y + data.cell.height / 2;
              const discountTextY = cellCenterY - 3;

              doc.setFontSize(10);
              doc.setTextColor(0, 0, 0);
              doc.text(discountText, textX, discountTextY, { align: "center" });

              if (product?.discount && product?.deliveryType !== "delivery") {
                const originalTextY = cellCenterY + 5;

                doc.setTextColor(0, 0, 0);
                doc.text(originalText, textX, originalTextY, {
                  align: "center",
                });

                const textWidth = doc.getTextWidth(originalText);
                const textHeight = 3;

                doc.setDrawColor(0, 0, 0);
                doc.setLineWidth(0.2);
                doc.line(
                  textX - textWidth / 2,
                  originalTextY - textHeight / 2,
                  textX + textWidth / 2,
                  originalTextY - textHeight / 2
                );
              }
            }

            if (data.column.index === 4 && data.row.section === "body") {
              const product = perSet.products[data.row.index];
              const discountedPrice = calculateWithDiscountPrice(product);
              const originalPrice =
                calculateSingleTotalPrice(product) || "0.00";

              const discountText = `$${discountedPrice}`;
              const originalText = `$${originalPrice}`;

              const textX = data.cell.x + data.cell.width / 2;
              const cellCenterY = data.cell.y + data.cell.height / 2;
              const discountTextY = cellCenterY - 3;

              doc.setFontSize(10);
              doc.setTextColor(0, 0, 0);
              doc.text(discountText, textX, discountTextY, { align: "center" });

              if (data.column.index === 4 && data.row.section === "body") {
                const product = perSet.products[data.row.index];
                const discountedPrice = calculateWithDiscountPrice(product);
                const originalPrice =
                  calculateSingleTotalPrice(product) || "0.00";

                const discountText = `$${discountedPrice}`;
                const originalText = `$${originalPrice}`;

                const textX = data.cell.x + data.cell.width / 2;
                const cellCenterY = data.cell.y + data.cell.height / 2;
                const discountTextY = cellCenterY - 3;

                doc.setFontSize(10);
                doc.setTextColor(0, 0, 0);
                doc.text(discountText, textX, discountTextY, {
                  align: "center",
                });

                // Only show original price with strikethrough if there's a discount and deliveryType is not "delivery"
                if (
                  product?.discount &&
                  product?.deliveryType !== "delivery" &&
                  product.discount !== "0"
                ) {
                  const originalTextY = cellCenterY + 5;

                  doc.setTextColor(0, 0, 0);
                  doc.text(originalText, textX, originalTextY, {
                    align: "center",
                  });

                  const textWidth = doc.getTextWidth(originalText);
                  const textHeight = 3;

                  doc.setDrawColor(0, 0, 0);
                  doc.setLineWidth(0.2);
                  doc.line(
                    textX - textWidth / 2,
                    originalTextY - textHeight / 2,
                    textX + textWidth / 2,
                    originalTextY - textHeight / 2
                  );
                }
              }
            }
          },
        });

        finalY = doc.lastAutoTable.finalY + 5;

        const summaryData = [
          [
            "Subtotal",
            `$${perSet.products
              .reduce(
                (acc, pro) =>
                  acc + (pro?.quantity || 0) * (pro?.selectedPricingValue || 0),
                0
              )
              .toFixed(2)}`,
          ],
        ];

        // Calculate discount total
        const discountTotal = calculateAllDiscountTotal(perSet.products);

        // Only add the "Discount Total" row if the discount is not 0.00 or 0
        if (discountTotal !== 0 && discountTotal !== "0.00") {
          summaryData.push(["Discount Total", `-$${discountTotal}`]);
        }

        // Calculate tax total
        const taxTotal = calculateTaxTotal(perSet.products);

        // Only add the "TAX Total" row if the tax is not 0.00 or 0
        if (taxTotal !== 0 && taxTotal !== "0.00") {
          summaryData.push(["Tax Total", `$ ${taxTotal}`]);
        }

        // Add the remaining rows
        summaryData.push(["Total", `$ ${calculateSetTotal(perSet.products)}`]);

        doc.autoTable({
          body: summaryData,
          startY: finalY,
          margin: { left: 120 },
          tableWidth: 80,
          styles: {
            fontSize: 12,
            cellPadding: 3,
            textColor: [0, 0, 0],
            fontStyle: "bold",
          },
          columnStyles: {
            0: { cellWidth: 50 },
            1: { cellWidth: 30, halign: "right" },
          },
          bodyStyles: { fillColor: [229, 231, 235] },
        });

        finalY = doc.lastAutoTable.finalY + 5;
      }
    });

    doc.setFont("Poppins", "bold");
    doc.setFontSize(14);
    finalY += 10;

    doc.line(10, finalY, 200, finalY);
    finalY += 10;

    const totalsData = [];

    // Helper function to add a row conditionally
    const addRowIfNonZero = (label, value) => {
      if (value !== 0 && value !== "0.00") {
        totalsData.push([label, value]);
      }
    };

    // Add rows conditionally
    addRowIfNonZero(
      "Sub Total",
      `$${calculateAllSetSubTotal(allSet) || "0.00"}`
    );
    addRowIfNonZero(
      "Discount",
      `-$${calculateAllSetDiscount(allSet) || "0.00"}`
    );
    addRowIfNonZero("Tax", `$${calculateAllSetTax(allSet) || "0.00"}`);
    addRowIfNonZero("Total", `$${calculateAllSetTotal(allSet) || "0.00"}`);

    // Add "Discount on Total" row if applicable
    if (products?.AllProductDiscount && products?.AllProductDiscount !== "0") {
      totalsData.push([
        "Discount on Total",
        `${products?.AllProductDiscount || "0"} ${
          products?.AllProductDiscountType || ""
        }`,
      ]);
    }

    // Add "Final Total" row
    totalsData.push([
      "Final Total",
      `$${calculateFinalTotal(allSet, products) || "0.00"}`,
    ]);

    // Add "Deposit" row if applicable
    if (
      products?.advanceDepositValue &&
      products?.advanceDepositValue !== "0"
    ) {
      totalsData.push([
        `Deposit (${products?.advanceDepositValue || "0"} ${
          products?.advanceDepositType || ""
        })`,
        `$${calculateDeposit(
          calculateFinalTotal(allSet, products),
          products?.advanceDepositValue || 0,
          products?.advanceDepositType || ""
        )}`,
      ]);
    }

    // Add "Amount Paid" and "Amount Due" rows
    addRowIfNonZero("Amount Paid", `$${totalPayAmount || "0.00"}`);
    addRowIfNonZero("Amount Due", `$${amountDue || "0.00"}`);

    // Calculate table width and margins
    const pageWidth = doc.internal.pageSize.getWidth();
    const tableWidth = pageWidth * 0.6; // 60% of page width
    const rightMargin = 10; // Right margin
    const leftMargin = pageWidth - tableWidth - rightMargin; // Left margin

    // Generate the table
    doc.autoTable({
      body: totalsData,
      startY: finalY,
      margin: { left: leftMargin }, // Use calculated left margin
      tableWidth: tableWidth, // Use calculated table width
      styles: {
        fontSize: 12,
        cellPadding: 3,
        textColor: [0, 0, 0],
        fontStyle: "bold",
      },
      columnStyles: {
        0: { cellWidth: tableWidth * 0.75 }, // 75% of table width for the first column
        1: { cellWidth: tableWidth * 0.25, halign: "right" }, // 25% of table width for the second column
      },
      headStyles: { fillColor: [59, 89, 152] }, // Header background color
      bodyStyles: { fillColor: [240, 240, 240] }, // Body background color
      theme: "striped", // Apply striped theme
    });

    // Update finalY to the bottom of the totalsData table
    finalY = doc.lastAutoTable.finalY + 10;

    // Add payment details section (right-aligned, 60% width)
    finalY = addPaymentDetails(
      doc,
      paymentData,
      finalY,
      tableWidth,
      leftMargin
    );

    // Add terms and conditions
    finalY = addTermsAndConditions(doc, data, finalY);

    // Add footer to all pages
    addFooter(doc);

    const fileName = `${products.firstName || "Document"}_${
      products.paymentId || "Invoice"
    }.pdf`;
    doc.save(fileName);
  };

  const printRef = useRef();

  const fetchStyles = async () => {
    const styles = [];

    // Inline <style> tags
    document.querySelectorAll("style").forEach((style) => {
      styles.push(style.innerHTML);
    });

    // Inline <link> tags (external stylesheets)
    const linkPromises = Array.from(
      document.querySelectorAll('link[rel="stylesheet"]')
    ).map(async (link) => {
      try {
        const response = await fetch(link.href, { mode: "cors" });
        if (response.ok) {
          const cssText = await response.text();
          styles.push(cssText);
        } else {
          console.warn("Failed to fetch stylesheet:", link.href);
        }
      } catch (err) {
        console.warn("Error fetching stylesheet:", link.href, err);
      }
    });

    await Promise.all(linkPromises);
    return styles.join("\n");
  };

  const handlePrint = async () => {
    try {
      const styles = await fetchStyles();

      const printFrame = document.createElement("iframe");
      printFrame.style.position = "fixed";
      printFrame.style.right = "0";
      printFrame.style.bottom = "0";
      printFrame.style.width = "0";
      printFrame.style.height = "0";
      printFrame.style.border = "0";
      printFrame.style.visibility = "hidden";
      document.body.appendChild(printFrame);

      const printDoc =
        printFrame.contentDocument || printFrame.contentWindow?.document;
      if (!printDoc) throw new Error("Failed to create print document");

      const contentClone = printRef.current.cloneNode(true);

      printDoc.open();
      printDoc.write(`
        <!DOCTYPE html>
        <html>
          <head>
            <title>Quote ${products.paymentId || "N/A"}</title>
            <meta charset="utf-8">
            <style>
              body {
                margin: 0;
                padding: 0;
                -webkit-print-color-adjust: exact;
                print-color-adjust: exact;
              }
              @page {
                size: auto;
                margin: 15mm 10mm;
              }
              .print-content {
                width: 850px;
                margin: 0 auto;
                padding: 40px;
              }
              ${styles}
              @media print {
                body * {
                  visibility: visible !important;
                }
                .print-content {
                  position: relative;
                  width: 100%;
                  padding: 0;
                  margin: 0;
                }
                .no-print {
                  display: none !important;
                }
              }
            </style>
          </head>
          <body>
            <div class="print-content">
              ${contentClone.innerHTML}
            </div>
          </body>
        </html>
      `);
      printDoc.close();

      printFrame.onload = function () {
        setTimeout(() => {
          printFrame.contentWindow?.focus();
          printFrame.contentWindow?.print();
          setTimeout(() => {
            document.body.removeChild(printFrame);
          }, 1000);
        }, 500);
      };
    } catch (error) {
      console.error("Print error:", error);
      window.print();
    }
  };

  return (
    <div>
      {loading ? (
        <div className="loading-spinner">
          <LoaderSpinner />
        </div>
      ) : error ? (
        <div className="loading-spinner">
          <LoaderSpinner />
        </div>
      ) : (
        <div className="min-h-screen bg-gray-200 py-28">
          <div className="w-[850px] mx-auto flex gap-5 py-4 ">
            {/* <button
              onClick={generatePDFTwo}
              className="px-6 py-2 rounded-full bg-indigo-500 text-white  text-sm text-wt-md font-jost"
            >
              Download Pdf
            </button> */}
            <button
              onClick={handlePrint}
              className="px-6 py-2 rounded-full bg-indigo-500 text-white  text-sm text-wt-md font-jost"
            >
              Download Pdf
            </button>
            <Link to={`/invoice/payment/${products._id}`}>
              <button className="px-6 py-2 rounded-full bg-indigo-500 text-white  text-sm text-wt-md font-jost">
                Pay Invoice
              </button>
            </Link>
          </div>
          <div
            ref={printRef}
            className="w-[850px] mx-auto print-content p-10  bg-white"
          >
            <div className="flex flex-row  justify-between items-start pb-5 w-full border-b border-gray-500">
              <div className="flex items-start">
                <img src={logo} alt="Company Logo" className="w-32  mr-4" />
                <div>
                  <h1 className="lg:text-lg md:text-md sm:text-md font-bold">
                    My Color Events and Design LLC
                  </h1>
                  <p className="lg:text-md md:text-sm sm:text-sm">
                    1565 Monroe Turnpike Monroe,
                  </p>
                  <p className="lg:text-md md:text-sm sm:text-sm">
                    Connecticut 06468 United States
                  </p>
                  <p className="lg:text-md md:text-sm sm:text-sm">
                    info@mycolorevents.com
                  </p>
                  <p className="lg:text-md md:text-sm sm:text-sm">
                    Phone: +1203-548-7769
                  </p>
                </div>
              </div>

              <div className="lg:text-right md:text-left sm:text-left">
                <h2 className="lg:text-lg md:text-md sm:text-md font-bold">
                  Quote: {products.paymentId || "N/A"}
                </h2>
                <p className="text-md">
                  Issue Date:{" "}
                  {products.createdAt
                    ? new Date(products.createdAt).toLocaleString("en-US", {
                        month: "short",
                        day: "numeric",
                        year: "numeric",
                        hour: "numeric",
                        minute: "2-digit",
                        hour12: true,
                      })
                    : "N/A"}
                </p>
              </div>
            </div>
            <div className="flex flex-row  justify-between items-start pt-5 w-full">
              <div>
                <h3 className="text-md font-bold mb-2">Contact</h3>
                <p className="text-md">
                  Name:{" "}
                  {`${products.firstName || ""} ${
                    products.lastName || ""
                  }`.trim() || "N/A"}
                </p>
                <p className="text-md">
                  Phone: {products.phoneNumber || "N/A"}
                </p>
                <p className="text-md">Email: {products.email || "N/A"}</p>
              </div>

              <div>
                <h3 className="text-md font-bold mb-2">Venue / Address</h3>
                <p className="text-md flex-wrap w-[350px]">
                  Address: {products.address || "N/A"}
                </p>
                <p className="text-md">City: {products.city || "N/A"}</p>
                <p className="text-md">State: {products.state || "N/A"}</p>
                <p className="text-md">
                  Post Code: {products.postCode || "N/A"}
                </p>
              </div>
            </div>
            {allSet.map((perSet, index) => (
              <div key={index} className="my-5 ">
                <div className="bg-blue-900 text-white p-2 rounded-t flex flex-col justify-between items-start">
                  <h4 className="text-lg font-bold">
                    {perSet.setTitle || "N/A"}
                  </h4>
                  <p className="lg:text-lg md:text-md sm:text-sm">
                    {perSet.startDate
                      ? new Date(perSet.startDate)
                          .toUTCString()
                          .replace("GMT", "")
                          .replace(/(\d{2}:\d{2}:\d{2})/, (match) => {
                            // Convert "14:10:00" → "2:10:00 PM"
                            const [h, m, s] = match.split(":");
                            const hour = h % 12 || 12;
                            const ampm = h >= 12 ? "PM" : "AM";
                            return `${hour}:${m}:${s} ${ampm}`;
                          })
                      : "N/A"}{" "}
                    -{" "}
                    {perSet.endDate
                      ? new Date(perSet.endDate)
                          .toUTCString()
                          .replace("GMT", "")
                          .replace(/(\d{2}:\d{2}:\d{2})/, (match) => {
                            // Convert "14:10:00" → "2:10:00 PM"
                            const [h, m, s] = match.split(":");
                            const hour = h % 12 || 12;
                            const ampm = h >= 12 ? "PM" : "AM";
                            return `${hour}:${m}:${s} ${ampm}`;
                          })
                      : "N/A"}
                  </p>
                </div>

                <div class="relative overflow-x-auto">
                  <table class="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
                    <thead class="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                      <tr>
                        <th scope="col" class="px-6 py-3">
                          Description
                        </th>
                        <th scope="col" class="px-6 py-3">
                          Quantity
                        </th>
                        <th scope="col" class="px-6 py-3">
                          Price
                        </th>
                        <th scope="col" class="px-6 py-3">
                          Total
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {perSet.products.map((pro, idx) => (
                        <tr class="bg-white  border-b dark:bg-gray-800 dark:border-gray-700 ">
                          <td class="px-6 py-4 text-md font-roboto text-gray-800">
                            <div className="flex flex-row gap-2">
                              <div class="w-[28%] h-28">
                                {pro?.deliveryType === "delivery" ? (
                                  <img
                                    alt=""
                                    class="w-28 h-28 rounded object-cover"
                                    src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEuMSIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHdpZHRoPSI1MTIiIGhlaWdodD0iNTEyIiB4PSIwIiB5PSIwIiB2aWV3Qm94PSIwIDAgNTEyIDUxMiIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNTEyIDUxMiIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSIgY2xhc3M9IiI+PGcgdHJhbnNmb3JtPSJtYXRyaXgoMSwwLDAsMSwwLDExMCkiPjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTM2NSAzLjAxNmM0NC4zOSAxMC4zIDYxLjM3MSAzNi4yNTcgODIuNjYgNzEuOTg0SDM2NXpNMTA1LjU3OCA3OGM4LjY5MiAwIDE1IDQuMTk1IDE1IDE0IDAgOC4yNy02LjY5MSAxNC45NzctMTQuOTU3IDE1SDE1Yy04LjI4NSAwLTE1IDYuNzE5LTE1IDE1IDAgOC4yODUgNi43MTUgMTUgMTUgMTVoMTM1YzguMzYzIDAgMTUuMDU5IDYuNzEgMTUuMDU5IDE1IDAgOC4yODUtNi43MTUgMTUtMTUgMTVIMTVjLTguMjg1IDAtMTUgNi43MTUtMTUgMTVzNi43MTUgMTUgMTUgMTVoMzN2NDVjMCA4LjI4NSA2LjcxNSAxNSAxNSAxNWgzMC4xNTJjNS4zNzUgMjYuNDc3IDI4Ljc3IDQ2IDU2LjM0OCA0NnM1MC45NzMtMTkuNTIzIDU2LjM0OC00NmgxNTIuMzA0YzUuMzc1IDI2LjQ3NyAyOC43NyA0NiA1Ni4zNDggNDZzNTAuOTczLTE5LjUyMyA1Ni4zNDgtNDZINDk3YzguMjg1IDAgMTUtNi43MTUgMTUtMTV2LTkwYzAtNDQuMDEyLTQ2LjQyMi00Ni45MzQtNDYuNDY1LTQ3SDM1MGMtOC4yODUgMC0xNS02LjcxNS0xNS0xNVYwSDYzYy04LjI4NSAwLTE1IDYuNzE1LTE1IDE1djMzSDMwYy04LjI4NSAwLTE1IDYuNzE1LTE1IDE1czYuNzE1IDE1IDE1IDE1em0zMjguMzY3IDE0OC4wNTVjMTAuNzM5IDEwLjczOCAxMC43MzkgMjguMTU2IDAgMzguODk0QzQxNi42NzIgMjgyLjIyMyAzODcgMjY5LjkzNCAzODcgMjQ1LjVjMC0yNC40MyAyOS42NzItMzYuNzE5IDQ2Ljk0NS0xOS40NDV6bS0yNjUgMGMxMC43MzkgMTAuNzM4IDEwLjczOSAyOC4xNTYgMCAzOC44OTRDMTUxLjY3MiAyODIuMjIzIDEyMiAyNjkuOTM0IDEyMiAyNDUuNWMwLTI0LjQzIDI5LjY3Mi0zNi43MTkgNDYuOTQ1LTE5LjQ0NXptMCAwIiBmaWxsPSIjMDAwMDAwIiBvcGFjaXR5PSIxIiBkYXRhLW9yaWdpbmFsPSIjMDAwMDAwIiBjbGFzcz0iIj48L3BhdGg+PC9nPjwvc3ZnPg=="
                                  />
                                ) : (
                                  <div>
                                    {pro.singleImage ? (
                                      <img
                                        class="w-28 h-28 rounded object-cover"
                                        src={pro.singleImage}
                                        alt="Rounded avatar"
                                      />
                                    ) : (
                                      <img
                                        class="w-28 h-28"
                                        src={noImage}
                                        alt="Rounded avatar"
                                      />
                                    )}
                                  </div>
                                )}
                              </div>
                              <div className="w-[72%]">
                                <strong>{pro?.title}</strong>
                                {pro?.deliveryType === "delivery" ||
                                pro?.deliveryType === "tear" ? (
                                  <h1>
                                    <span>
                                      {pro?.deliveryType === "tear" ? (
                                        ""
                                      ) : (
                                        <span>
                                          Start Date :
                                          {new Date(
                                            pro.startDate
                                          ).toLocaleString("en-US", {
                                            month: "short",
                                            day: "numeric",
                                            year: "numeric",
                                            hour: "numeric",
                                            minute: "2-digit",
                                            hour12: true,
                                          })}
                                        </span>
                                      )}
                                    </span>
                                  </h1>
                                ) : (
                                  ""
                                )}
                                <div className="flex flex-col gap-2 w-full mt-2">
                                  <span className="text-justify">
                                    <strong>Description : </strong>
                                    {pro?.description ? (
                                      <div
                                        className="text-justify"
                                        dangerouslySetInnerHTML={{
                                          __html: pro?.description,
                                        }}
                                      ></div>
                                    ) : (
                                      ""
                                    )}
                                  </span>
                                  <span className="text-justify">
                                    {pro?.color &&
                                    pro.color.trim() !== "" &&
                                    /\d/.test(pro.color)
                                      ? `Color: ${pro.color}, `
                                      : ""}
                                    {pro?.height &&
                                    pro.height.trim() !== "" &&
                                    /\d/.test(pro.height)
                                      ? `Height: ${pro.height}, `
                                      : ""}
                                    {pro?.length &&
                                    pro.length.trim() !== "" &&
                                    /\d/.test(pro.length)
                                      ? `Length: ${pro.length}, `
                                      : ""}
                                    {pro?.width &&
                                    pro.width.trim() !== "" &&
                                    /\d/.test(pro.width)
                                      ? `Width: ${pro.width}, `
                                      : ""}
                                    {pro?.shape &&
                                    pro.shape.trim() !== "" &&
                                    /\d/.test(pro.shape)
                                      ? `Shape: ${pro.shape}`
                                      : ""}
                                  </span>
                                  <span className="text-justify">
                                    <strong>Notes</strong>: {pro?.internalNotes}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </td>

                          {pro?.deliveryType === "delivery" ||
                          pro?.deliveryType === "tear" ? (
                            <td></td>
                          ) : (
                            <td class="px-6 py-4 text-md font-roboto text-gray-800">
                              {pro?.quantity}
                            </td>
                          )}
                          {pro?.deliveryType === "delivery" ? (
                            <td></td>
                          ) : (
                            <td class="px-6 py-4 text-md font-roboto   text-gray-800">
                              <div className="flex flex-col">
                                <span>
                                  {calculateDiscountSelectedPrice(pro)}
                                </span>
                                {pro?.discount && pro.discount !== "0" ? (
                                  <del className="mt-1">
                                    {pro?.selectedPricingValue}
                                  </del>
                                ) : (
                                  ""
                                )}
                              </div>
                            </td>
                          )}
                          <td class="px-6 py-4 text-md font-roboto text-gray-800">
                            <div>{calculateWithDiscountPrice(pro)}</div>
                            {pro?.discount && pro.discount !== "0" ? (
                              <del className="mt-1">
                                {calculateSingleTotalPrice(pro)}
                              </del>
                            ) : (
                              ""
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

                <div className="">
                  <div className="flex justify-end items-center w-full">
                    <table className="lg:w-[40%] md:w-[80%] sm:w-[90%] text-sm border border-gray-200 bg-gray-100">
                      <tbody className="text-lg font-semibold">
                        <tr className="border-b border-gray-200">
                          <td className="text-left p-2">Subtotal:</td>
                          <td className="text-right p-2">
                            ${calculateSetSubTotal(perSet.products)}
                          </td>
                        </tr>
                        {calculateAllDiscountTotal(perSet.products) !== 0 &&
                          calculateAllDiscountTotal(perSet.products) !==
                            "0.00" && (
                            <tr className="border-b border-gray-200">
                              <td className="text-left p-2">Discount Total:</td>
                              <td className="text-right p-2">
                                -${calculateAllDiscountTotal(perSet.products)}
                              </td>
                            </tr>
                          )}
                        {calculateTaxTotal(perSet.products) !== 0 &&
                          calculateTaxTotal(perSet.products) !== "0.00" && (
                            <tr className="border-b border-gray-200">
                              <td className="text-left p-2">Tax Total:</td>
                              <td className="text-right p-2">
                                ${calculateTaxTotal(perSet.products)}
                              </td>
                            </tr>
                          )}

                        <tr>
                          <td className="text-left p-2 font-bold">Total:</td>
                          <td className="text-right p-2 font-bold">
                            ${calculateSetTotal(perSet.products)}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            ))}
            <div className="w-full flex justify-end ">
              <div className="rounded lg:w-[60%] md:w-[80%] sm:w-[100%] ">
                <h1 className="text-xl font-semibold mt-6 bg-blue-900 text-white p-2">
                  Totals
                </h1>
                <table className="w-full border-collapse border border-gray-300 bg-gray-100">
                  <tbody>
                    <tr>
                      <td className="p-2 border border-gray-300 text-lg font-semibold ">
                        Sub Total:
                      </td>
                      <td className="p-2 border border-gray-300 text-lg font-semibold text-right">
                        ${calculateAllSetSubTotal(allSet)}
                      </td>
                    </tr>
                    {calculateAllSetDiscount(allSet) !== 0 &&
                      calculateAllSetDiscount(allSet) !== "0.00" && (
                        <tr className="border-b border-gray-200">
                          <td className="p-2 border border-gray-300 text-lg font-semibold text-left">
                            Discount:
                          </td>
                          <td className="p-2 border border-gray-300 text-lg font-semibold text-right">
                            -${calculateAllSetDiscount(allSet)}
                          </td>
                        </tr>
                      )}
                    {calculateAllSetTax(allSet) !== 0 &&
                      calculateAllSetTax(allSet) !== "0.00" && (
                        <tr className="border-b border-gray-200">
                          <td className="p-2 border border-gray-300 text-lg font-semibold text-left">
                            Tax:
                          </td>
                          <td className="p-2 border border-gray-300 text-lg font-semibold text-right">
                            ${calculateAllSetTax(allSet)}
                          </td>
                        </tr>
                      )}

                    <tr className="font-bold">
                      <td className="p-2 border border-gray-300 text-lg font-semibold ">
                        Total:
                      </td>
                      <td className="p-2 border border-gray-300 text-lg font-semibold text-right">
                        ${calculateAllSetTotal(allSet)}
                      </td>
                    </tr>
                    {products?.AllProductDiscount &&
                      products?.AllProductDiscount !== "0" && (
                        <tr>
                          <td className="p-2 border border-gray-300 text-lg font-semibold">
                            Discount on Total:
                          </td>
                          <td className="p-2 border border-gray-300 text-lg font-semibold text-right">
                            {products?.AllProductDiscount || "0"}{" "}
                            {products?.AllProductDiscountType || ""}
                          </td>
                        </tr>
                      )}
                    {products?.AllProductDiscount &&
                      products?.AllProductDiscount !== "0" && (
                        <tr className="font-bold">
                          <td className="p-2 border border-gray-300 text-lg font-semibold ">
                            Final Total:
                          </td>
                          <td className="p-2 border border-gray-300 text-lg font-semibold text-right">
                            ${calculateFinalTotal(allSet, products)}
                          </td>
                        </tr>
                      )}

                    <tr>
                      <td className="p-2 border border-gray-300 text-lg font-semibold ">
                        Deposit ({products?.advanceDepositValue || "0"}{" "}
                        {products?.advanceDepositType || ""}):
                      </td>
                      <td className="p-2 border border-gray-300 text-lg font-semibold text-right">
                        $
                        {calculateDeposit(
                          calculateFinalTotal(allSet, products),
                          products?.advanceDepositValue || 0,
                          products?.advanceDepositType || ""
                        )}
                      </td>
                    </tr>
                    <tr>
                      <td className="p-2 border border-gray-300 text-lg font-semibold">
                        Amount Paid:
                      </td>
                      <td className="p-2 border border-gray-300 text-lg font-semibold text-right">
                        ${totalPayAmount || "0.00"}
                      </td>
                    </tr>
                    <tr className="font-bold">
                      <td className="p-2 border border-gray-300 text-lg font-semibold">
                        Amount Due:
                      </td>
                      <td className="p-2 border border-gray-300 text-lg font-semibold text-right">
                        ${amountDue || "0.00"}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            {/* payment start*/}
            <div className="w-full rounded-lg  flex justify-end mt-5">
              <div className="w-[60%]">
                {paymentData?.length > 0 ? (
                  <div className="w-full ">
                    {/* const paid amount start*/}
                    <div className="w-full bg-white">
                      {paymentData?.length > 0 ? (
                        <div className="">
                          <h1 className="text-xl font-roboto text-gray-500">
                            Payment received{" "}
                          </h1>
                          <div className="flex flex-col gap-5 mt-4  h-[400px] overflow-auto">
                            {paymentData?.map((payment, index) => (
                              <div
                                className="bg-gray-100 p-4 rounded"
                                key={index}
                              >
                                <p className="font-roboto text-xl text-gray-700">
                                  <strong>Amount:</strong> ${payment?.payAmount}
                                </p>
                                {payment?.paymentMethod ? (
                                  <p className="font-roboto text-md text-gray-700">
                                    <strong>Payment Method :</strong>{" "}
                                    {payment?.paymentMethod}
                                  </p>
                                ) : (
                                  <div>
                                    <p className="font-roboto text-md text-gray-700">
                                      <strong>Payment Method :</strong> Stripe
                                    </p>
                                    <p className="font-roboto text-md text-gray-700">
                                      <strong>Stripe ID:</strong>{" "}
                                      {payment?.stripePaymentId}
                                    </p>
                                  </div>
                                )}
                                {payment?.PaymentDate ? (
                                  <p className="font-roboto text-sm text-gray-700">
                                    <strong>Payment Date:</strong>{" "}
                                    {new Date(
                                      payment.PaymentDate
                                    ).toLocaleString("en-US", {
                                      month: "short",
                                      day: "numeric",
                                      year: "numeric",
                                      hour: "numeric",
                                      minute: "2-digit",
                                      hour12: true,
                                    })}
                                  </p>
                                ) : (
                                  <p className="font-roboto text-sm text-gray-700">
                                    <strong>Payment Date:</strong>{" "}
                                    {new Date(payment.createdAt).toLocaleString(
                                      "en-US",
                                      {
                                        month: "short",
                                        day: "numeric",
                                        year: "numeric",
                                        hour: "numeric",
                                        minute: "2-digit",
                                        hour12: true,
                                      }
                                    )}
                                  </p>
                                )}
                              </div>
                            ))}
                          </div>
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                    {/* const paid amount end*/}
                  </div>
                ) : (
                  ""
                )}
              </div>
            </div>

            {/* payment end*/}
            <div
              className="prose prose-blue max-w-none mt-10"
              dangerouslySetInnerHTML={{ __html: renderSelectedContent() }}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default OrderDetailsPage;
